<template>
  <div class="u-music">
    <div class="musicBox" @click="playBtn">
      <img :src="bgmIcon">
      <!-- <audio id="bgm" src="../../assets/img/bgm.mp3"></audio> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'u-music',
  data () {
    return {
      bgm: null,
      btn_bgm: null,
      isPlay: false,
      bgmIcon: 'https://cmbc-zg.oss-cn-shenzhen.aliyuncs.com/pause.png'
    }
  },
  props: {},
  mounted () {
    // this.bgm = document.getElementById('bgm')
    // console.log('this.bgm', this.bgm)
    const bgm = require('../../assets/img/bgm.mp3')
    this.bgm = new Audio(bgm)
    // 音效
    const mp3 = require('../../assets/img/btn_music.mp3')
    this.btn_bgm = new Audio(mp3)
    // document.addEventListener('WeixinJSBridgeReady', () => {
    //   this.bgm.play()
    // }, false)
  },
  methods: {
    playBtn () {
      if (!this.isPlay) {
        this.prePlay(0)
        this.bgm.play()
        this.isPlay = true
        this.bgm.loop = true
        this.bgmIcon = 'https://cmbc-zg.oss-cn-shenzhen.aliyuncs.com/playing.gif'
        this.$stat({
          event: 'on_bgm' // 上报埋点信息
        })
      } else {
        this.bgm.pause()
        this.isPlay = false
        this.bgmIcon = 'https://cmbc-zg.oss-cn-shenzhen.aliyuncs.com/pause.png'
        this.$stat({
          event: 'close_bgm' // 上报埋点信息
        })
      }
    },
    toStop () {
      if (this.isPlay) {
        this.playBtn()
      }
    },
    prePlay (val) {
      if (val) {
        this.bgm.muted = true
        this.bgm.play()
        this.btn_bgm.muted = true
        this.btn_bgm.play()
      } else {
        this.bgm.muted = false
        this.bgm.pause()
      }
    },
    playBtnBgm () {
      this.btn_bgm.muted = false
      this.btn_bgm.play()
    }
  }
}
</script>

<style lang="scss" scoped>
.u-music{
}
.musicBox{
  position: absolute;
  top: 15%;
  right: 2.7%;
  width: 16%;
  height: auto;
  z-index: 2;
  img{
    width: 100%;
    height: auto;
    pointer-events: none;
  }
  .turnRotate{
    animation: turnRotate 1.5s infinite linear;
  }
}
</style>
